<template>
    <div class="form-group form-group-checkbox" v-bind:class="{'dark': this.getDesign() == 'black', 'white' : this.getDesign() == 'white'}">
        <label>{{ $t(this.field.name) }}</label>
        <input type="checkbox" v-model="value" :required="field.isRequired" @change="changeField">
    </div>
</template>

<script>

    import { mapGetters } from 'vuex';
    import { mapMutations } from 'vuex';

    export default {
        name: "checkbox",
        props: ["field","experience","room","start"],
        data() {
            return {
                value: false,
            }
        },
        created() {
            if(this.field.value) {
                this.value = this.field.value;
            }
            this.changeField();
        },
        computed: {
            ...mapGetters(['getDesign','getCheckout'])
        },
        methods: {
            ...mapMutations(['updateItemField']),
            changeField: function () {
                const newField =  {
                    id: this.$uuid.v4(this.field.id),
                    name: this.field.name,
                    title: this.field.name,
                    value: this.value,
                    amount: 0,
                    total: 0,
                    id_custom_fields_options: this.field.id_custom_fields_options
                };
                this.updateItemField({id_experience: this.experience, id_calendario : this.room, start: this.start, newField: newField});

                if(this.getCheckout().id) {
                    this.$emit('change-field');
                }
            },
        }
    }
</script>
